export enum VerificationProcessActionType {
  GetCurrentAccount = 'verificationProcess/getCurrentAccount',
  SendEmailVerificationCode = 'verificationProcess/sendEmailVerificationCode',
  VerifyEmailVerificationCode = 'verificationProcess/verifyEmailVerificationCode',
  SendPhoneVerificationCode = 'verificationProcess/sendPhoneVerificationCode',
  VerifyPhoneVerificationCode = 'verificationProcess/verifyPhoneVerificationCode',
}
